import React from 'react';
import supabase from '../helper/supabaseClient';
import { useEffect, useState } from 'react'
import { useUserProfile } from '../helper/UserProfile';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import '../stylesheets/dashboard.scss';
import '../stylesheets/profile.scss';
import MobileProfile from './mobile/MobileProfile';

function Profile({}) {
  
  const [firstName, setFirstName] = useState("")
  const [surname, setSurname] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [address, setAddress] = useState("")
  const [workAddress, setWorkAddress] = useState("")
  const [id, setId] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [member, setMember] = useState("");

  const { profile, setProfile, refreshProfile, loading } = useUserProfile();
  const navigate = useNavigate();

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault()

    if(!firstName || !surname || !email || !phone ) {
      setError("Fill out required fields")
      return
    }

    const { data: profileData, error: profileError } = await supabase
      .from('profile')
      .update({
        first_name: firstName,
        surname: surname,
        email: email,
        phone: phone,
        address: address,
        place_of_work: workAddress,
      })
      .eq('id', id)
      .select()

      if (profileError) {
        console.error(profileError);
        setError("There has been an issue");
        return
      }

      const { data: revalData, error: revalError } = await supabase
      .from ('reval_members')
      .update({
        first_name: firstName,
        surname: surname,
      })
      .eq('id', id)
      .select();

      if (revalError) {
        console.error(revalError);
        setError("There has been an issue updating revalidation details");
        return
      }

        setSuccess("Your information has been updated");
        setError("");
        await refreshProfile();
  };

  useEffect(() => {
    if (!profile) return;
    setFirstName(profile.first_name);
    setSurname(profile.surname);
    setEmail(profile.email);
    setPhone(profile.phone);
    setAddress(profile.address);
    setWorkAddress(profile.place_of_work);
    setId(profile.id);
    setMember(profile.revalidation_membership);
  }, [profile]);

    if (loading) return <div><FontAwesomeIcon icon={faSpinner} style={{position: "absolute", top: "5rem", left: "50%", transform: "translate(-50%, 0)", fontSize: "40px"}}/></div>;

    if (!profile) return <div>No profile found.</div>;

  return (
    <div>
      <div className="mob-only">
        <MobileProfile />
      </div>  

      <div className="dashboard-body">
        <h1>YOUR PROFILE PAGE</h1>
        <p>Here you can view or update your user information.</p>
        
        
        <div className="profile profile-table">
          <form onSubmit={handleSubmit} className="form">
            <table>
              <tbody>
                <tr>
                  <th style={{textAlign:"left", paddingRight:"1rem"}}>First Name</th>
                  <td>
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required>
                        </input>
                  </td>
                </tr>
                <tr>
                  <th style={{textAlign:"left", paddingRight:"1rem"}}>Surname</th>
                  <td>
                      <input type="text" value={surname} onChange={(e) => setSurname(e.target.value)} required></input>
                  </td>
                </tr>
                <tr>
                  <th style={{textAlign:"left", paddingRight:"1rem"}}>Email</th>
                  <td>
                      <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} required></input>
                  </td>
                </tr>
                <tr>
                  <th style={{textAlign:"left", paddingRight:"1rem"}}>Phone</th>
                  <td>
                      <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} required></input>
                  </td>
                </tr>
                <tr>
                  <th style={{textAlign:"left", paddingRight:"1rem"}}>Address</th>
                  <td>
                    <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} required></input>
                  </td>
                </tr>
                <tr>
                  <th style={{textAlign:"left", paddingRight:"1rem"}}>Place of Work</th>
                  <td>
                    <input type="text" value={workAddress} onChange={(e) => setWorkAddress(e.target.value)} required></input></td>
                </tr>
              </tbody>
            </table>
          <br></br>
          <button type="submit">Update</button>
          </form>
          <br></br>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success">{success}</p>}
        </div>
        
        <button className="mob-only signoutButton" onClick={signOut}>SIGN OUT</button>

      </div>
    </div>
  );
}

export default Profile;